interface PersonNode {
  uuid?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  agent?: boolean | null;
  status?: string | null;
}

interface PersonEdge {
  node: PersonNode;
}

export interface MappedBroker {
  id: string;
  uuid: string;
  name: string;
  broker: string;
  brokerage: string;
  status: string;
  agent: boolean;
  source: string;
  office?: string;
  team?: string;
  primaryContact: boolean;
}

export function mapPersonsToBrokers(
  personEdges: PersonEdge[],
  contextInfo?: {
    officeName?: string;
    teamName?: string;
  }
): MappedBroker[] {
  return personEdges.map((personEdge) => {
    const person = personEdge.node;
    const fullName = `${person.firstName || ''} ${
      person.lastName || ''
    }`.trim();

    const broker: MappedBroker = {
      id: person.uuid || '',
      uuid: person.uuid || '',
      name: fullName,
      broker: fullName,
      brokerage: '—', // Not available in these queries
      status: person.status || 'ACTIVE',
      agent: person.agent || false,
      source: '—', // Not available in these queries
      primaryContact: false, // Not available in these queries
    };

    if (contextInfo?.officeName) {
      broker.office = contextInfo.officeName;
    }

    if (contextInfo?.teamName) {
      broker.team = contextInfo.teamName;
    }

    return broker;
  });
}
